const domainDetector = {
	name: 'domain',

	lookup() {
		const domain = window.location.hostname;
		const language = domain.includes('cn') ? 'cn' : 'en';
		return language;
	}
};

export default domainDetector;
